import VueCookies from 'vue-cookies';

// Every screen renders its own Layout, so the assistant widget is re-created on each
// navigation. The conversation is kept in sessionStorage so it survives page changes.
const KEY_PREFIX = 'gc-assistant-session';
const MAX_MESSAGES = 60;

const storageKey = () => `${KEY_PREFIX}:${VueCookies.get('un') || 'anonymous'}`;

export const loadAssistantSession = () => {
  try {
    const raw = window.sessionStorage.getItem(storageKey());
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const saveAssistantSession = (state) => {
  try {
    const messages = (state.messages || []).slice(-MAX_MESSAGES);
    window.sessionStorage.setItem(storageKey(), JSON.stringify({ ...state, messages }));
  } catch (error) {
    // Storage full or blocked: the chat still works, it just won't survive navigation.
  }
};

export const clearAssistantSessions = () => {
  try {
    Object.keys(window.sessionStorage)
      .filter((key) => key.startsWith(KEY_PREFIX))
      .forEach((key) => window.sessionStorage.removeItem(key));
  } catch (error) {
    // Ignore: nothing to clear.
  }
};
